<template>
  <div>
    <select class="form-control" name="expire_date_select" v-model="selectedOption">
      <option value="">{{ __('must_selected') }}</option>
      <option value="select_year">年月日入力</option>
      <option value="no_select_year">期限切れ</option>
    </select>
    <div v-if="selectedOption === 'select_year'">
      <DateComponent v-model="from" :no_sec="no_sec" :name="attribute_name" />
    </div>
    <div v-if="selectedOption === 'no_select_year'">
      <!-- 期限切れの場合は自動的に日付が設定されるので表示しない -->
      <input type="hidden" :name="attribute_name" :value="from">
    </div>
  </div>
</template>
<script>

import moment from 'moment';
import DateComponent from './DateTimeComponent.vue';
// import axios from 'axios';

export default {
  name: 'ExpireDateComponent',
  components: {
    // 子コンポーネントを登録
    DateComponent,
  },
  props: {
    initialFrom: {
      type: String,
      default: '',
    },
    attribute_name: {
      type: String,
      default: 'expire_date',
    },
    initialSelected: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      selectedOption: this.initialSelected,
      no_sec: true,
      from: this.initialFrom,
    };
  },
  watch: {
    selectedOption(newVal) {
      if (newVal === 'no_select_year') {
        // "no_select_year"の場合、fromに昨日の日付を設定
        this.from = moment().subtract(1, 'days').format('YYYY-MM-DD');
      } else {
        // "select_year",""の場合、fromをリセット
        this.from = '';
      }
    },
  },
}
</script>
